export const ARTICLE_TYPES_GROUPED = [1, 3, 5, 6, 7, 11, 2, 4, 10];
export const ARTICLE_TYPES_ALLOWED = [1, 3, 6];

export enum TIMING_ARTICLE_TYPE_ID {
  TUBE_OR_CURVE = 1,
  CANOPY = 4,
}

export const PREPARATION_TIMES = {
  3: 1.82,
  2: 1.34,
  4: 2.08,
  1: 1.28,
};

export const ASSEMBLY_TIMES = {
  3: 6,
  2: 5.2,
  4: 5.2,
  1: 5.2,
};

export const PACKAGING_TIMES = {
  3: 5.7,
  2: 2.5,
  4: 8.2,
  1: 3.7,
};

export const TIMINGS = {
  PREPARATION: PREPARATION_TIMES,
  ASSEMBLY: ASSEMBLY_TIMES,
  PACKAGING: PACKAGING_TIMES,
};
